import React from 'react';
import ObtainorderStaticsContainer from '../../containers/obtainorder_statics/ObtainorderStaticsContainer';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const ObtainorderStaticsPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="통계/수주관리/수주 통계" icon="statistics" />
      <ObtainorderStaticsContainer />
    </>
  );
};

export default ObtainorderStaticsPage;
